/* eslint-disable react-hooks/exhaustive-deps */

import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import "./styles/RevisionTask.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DeleteOutline } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { TaskCards } from "../TaskList/components/TaskCards";

const fixThumbnailUrl = (url) => {
  if (!url) {
    return process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png";
  }

  if (url.startsWith("https://")) {
    return url;
  } else {
    return "https://xcell-cms-files.s3.amazonaws.com/" + url;
  }
};

const RevisionTaskStyle = {
  backgroundImage: `url(${
    process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png"
  })`,
  backgroundSize: "cover",
  minHeight: "245px",
  height: "100%",
  borderBottomRightRadius: "17px",
  borderBottomLeftRadius: "17px",
};

const RevisionTask = ({ selectedClass, selectedSubject }) => {
  const [revisionTasks, setRevisionTasks] = useState([]);
  const [revisionTaskLoader, setRevisionTaskLoader] = useState(true);

  useEffect(() => {
    const fetchRevisionTasks = async () => {
      const authToken = localStorage.getItem("authToken");
      const date = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      ).toISOString();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN}/api/v1/tasks?public=true&taskType=revision task&section=${selectedClass}&subject=${selectedSubject}`,
          {
            headers: {
              token: authToken,
            },
          },
        );
        if (response.data.status === "success") {
          setRevisionTasks(response.data.data.tasks);
        }
      } catch (error) {
        console.log(error);
      }

      setRevisionTaskLoader(false);
    };

    fetchRevisionTasks();
  }, [selectedClass, selectedSubject]);

  return (
    <TaskCards
      tasks={revisionTasks}
      setTasks={setRevisionTasks}
      loading={revisionTaskLoader}
      message={"No revision task assigned"}
    />
  );
};

export default RevisionTask;
